/*! PlayAh VN Address Form v3.9 — EMAIL REQUIRED (base: v3.2 KITE-FIX)
 *  Changes vs v3.2:
 *   4) EMAIL REQUIRED 2026-08-25: email quay lại thành trường BẮT BUỘC
 *      (thêm vào requiredChecks + required attr trong section liquid).
 *      Các trường khác giữ nguyên như v3.2.
 *  Changes vs v3.1 (live):
 *   3) KITE-FIX 2026-07-20: BỎ cart permalink. Permalink (/cart/variant:qty) tạo giỏ MỚI
 *      → mất line properties (_free_product, _rule_id) + cart attributes (kite_campaign)
 *      → app free-gift (Kite) không nhận diện được quà → gift mất giảm giá ở checkout.
 *      Fix: giữ nguyên giỏ hiện tại, redirect thẳng /checkout?checkout[...]=...
 *      - Prefill địa chỉ qua checkout[...] params vẫn hoạt động trên /checkout (test 20/7/2026).
 *      - KHÔNG truyền attributes[...] qua URL nữa: query attributes GHI ĐÈ toàn bộ cart
 *        attributes và xoá kite_campaign/_kite_ccdData. Attributes + note đã lưu qua
 *        /cart/update.js trước khi redirect (Pancake vẫn đọc từ order.note_attributes).
 *  Changes vs v2 (.live):
 *   1) FAIL-SAFE: default Shopify checkout button is only hidden AFTER the VN
 *      address data has loaded successfully. If the data/JS fails to load
 *      (slow/flaky mobile network), the native checkout stays usable so the
 *      sale is never lost silently.
 *   2) EMAIL OPTIONAL (đã đảo ngược ở v3.9 — xem mục 4).
 *   Ward (Phường/Xã) intentionally stays REQUIRED — VN address accuracy.
 */
(function() {
  'use strict';

  const form = document.getElementById('playah-vn-form');
  if (!form) return;

  const section = document.getElementById('playah-vn-checkout');
  const dataUrl = section.dataset.vnAddrUrl;
  const $province = document.getElementById('playah-vn-province');
  const $district = document.getElementById('playah-vn-district');
  const $ward = document.getElementById('playah-vn-ward');

  let ADDR_DATA = null;
  const provincesMap = new Map();
  const districtsMap = new Map();

  // (1) FAIL-SAFE — do NOT hide native checkout until the VN form is usable.
  let addrReady = false;
  function hideDefaultCheckout() {
    if (!addrReady) return; // never hide before the address form can work
    document.querySelectorAll('.cart__footer__checkout, .checkout__button[name="checkout"]').forEach(el => {
      el.style.display = 'none';
    });
  }
  function showDefaultCheckout() {
    document.querySelectorAll('.cart__footer__checkout, .checkout__button[name="checkout"]').forEach(el => {
      el.style.display = '';
    });
  }
  document.addEventListener('cart:updated', hideDefaultCheckout);

  function restoreFromCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const a = cart.attributes || {};
        if (a.vn_full_name) form.elements.full_name.value = a.vn_full_name;
        if (a.vn_phone) form.elements.phone.value = a.vn_phone;
        if (a.vn_email) form.elements.email.value = a.vn_email;
        if (a.vn_address_detail) form.elements.address_detail.value = a.vn_address_detail;
        if (a.vn_note) form.elements.note.value = a.vn_note;
      })
      .catch(() => {});
  }

  // Load address data
  fetch(dataUrl)
    .then(r => r.json())
    .then(data => {
      ADDR_DATA = data;
      // Sort: HCM first, Hà Nội second, rest alphabetical (Vietnamese locale)
      // Match by NAME to be robust across code systems (TCTK vs Pancake)
      data.sort((a, b) => {
        if (a[1] === 'Hồ Chí Minh') return -1;
        if (b[1] === 'Hồ Chí Minh') return 1;
        if (a[1] === 'Hà Nội') return -1;
        if (b[1] === 'Hà Nội') return 1;
        return a[1].localeCompare(b[1], 'vi');
      });
      const frag = document.createDocumentFragment();
      data.forEach(p => {
        provincesMap.set(p[0], p);
        const opt = document.createElement('option');
        opt.value = p[0];
        opt.textContent = p[1];
        frag.appendChild(opt);
      });
      $province.appendChild(frag);
      // (1) Form is now usable → safe to take over checkout.
      addrReady = true;
      hideDefaultCheckout();
      restoreFromCart();
    })
    .catch(err => {
      console.error('[PlayAh VN] Address data load failed:', err);
      // (1) FAIL-SAFE: keep the native Shopify checkout so the buyer can still
      // complete the order; hide the broken VN form to avoid confusion.
      addrReady = false;
      showDefaultCheckout();
      if (section) section.style.display = 'none';
    });

  $province.addEventListener('change', function() {
    const provCode = this.value;
    $district.innerHTML = '<option value="">— Chọn Quận/Huyện —</option>';
    $ward.innerHTML = '<option value="">— Chọn Phường/Xã —</option>';
    $district.disabled = true;
    $ward.disabled = true;
    districtsMap.clear();
    if (!provCode) return;
    const prov = provincesMap.get(provCode);
    if (!prov) return;
    const frag = document.createDocumentFragment();
    prov[2].forEach(d => {
      districtsMap.set(d[0], d);
      const opt = document.createElement('option');
      opt.value = d[0];
      opt.textContent = d[1];
      frag.appendChild(opt);
    });
    $district.appendChild(frag);
    $district.disabled = false;
  });

  $district.addEventListener('change', function() {
    const distCode = this.value;
    $ward.innerHTML = '<option value="">— Chọn Phường/Xã —</option>';
    $ward.disabled = true;
    if (!distCode) return;
    const dist = districtsMap.get(distCode);
    if (!dist || !dist[2] || !dist[2].length) {
      $ward.innerHTML = '<option value="0">(Không có Phường/Xã - nhập trong địa chỉ chi tiết)</option>';
      $ward.disabled = false;
      $ward.value = '0';
      return;
    }
    const frag = document.createDocumentFragment();
    dist[2].forEach(w => {
      const opt = document.createElement('option');
      opt.value = w[0];
      opt.textContent = w[1];
      frag.appendChild(opt);
    });
    $ward.appendChild(frag);
    $ward.disabled = false;
  });

  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    const submitBtn = form.querySelector('.playah-vn-submit');
    submitBtn.disabled = true;
    const origText = submitBtn.textContent;
    submitBtn.textContent = 'Đang xử lý…';

    try {
      const landingVariantId = form.dataset.landingVariantId;
      if (landingVariantId) {
        const qtyInputId = form.dataset.landingQtyInputId || 'playah-landing-qty';
        const qtyEl = document.getElementById(qtyInputId);
        const qty = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10) || 1) : 1;
        const variantIdNum = parseInt(landingVariantId, 10);
        try {
          const clearRes = await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
          if (!clearRes.ok) console.warn('[PlayAh VN landing] cart/clear non-OK:', clearRes.status);
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantIdNum, quantity: qty }] })
          });
          if (!addRes.ok) {
            const txt = await addRes.text();
            console.error('[PlayAh VN landing] cart/add failed', addRes.status, txt.slice(0, 200));
            alert('Không thể thêm sản phẩm vào giỏ hàng (lỗi ' + addRes.status + '). Vui lòng tải lại trang và thử lại.');
            submitBtn.disabled = false; submitBtn.textContent = origText; return;
          }
        } catch (addErr) {
          console.error('[PlayAh VN landing] add to cart exception:', addErr);
          alert('Không thể thêm sản phẩm vào giỏ hàng. Vui lòng tải lại trang và thử lại.\n' + (addErr.message || ''));
          submitBtn.disabled = false; submitBtn.textContent = origText; return;
        }
        // (3) KITE-FIX: không cần itemsParam nữa — sản phẩm landing đã nằm trong giỏ,
        // redirect /checkout dùng chính giỏ này.
      }

      const fullName = form.elements.full_name.value.trim();
      const phone = form.elements.phone.value.trim().replace(/\s/g, '');
      const email = form.elements.email.value.trim();
      const addressDetail = form.elements.address_detail.value.trim();
      const note = form.elements.note.value.trim();

      const provCode = $province.value;
      const distCode = $district.value;
      const wardCode = $ward.value;

      const invalids = [];
      form.querySelectorAll('.playah-vn-field--invalid').forEach(f => f.classList.remove('playah-vn-field--invalid'));

      // (4) v3.9: EMAIL bắt buộc trở lại — thêm vào requiredChecks. Ward vẫn required.
      const requiredChecks = [
        { value: fullName,      el: form.elements.full_name,      label: 'Họ và tên' },
        { value: phone,         el: form.elements.phone,          label: 'Số điện thoại' },
        { value: email,         el: form.elements.email,          label: 'Email' },
        { value: provCode,      el: $province,                    label: 'Tỉnh/Thành phố' },
        { value: distCode,      el: $district,                    label: 'Quận/Huyện' },
        { value: wardCode,      el: $ward,                        label: 'Phường/Xã' },
        { value: addressDetail, el: form.elements.address_detail, label: 'Địa chỉ chi tiết' }
      ];
      requiredChecks.forEach(c => {
        if (!c.value) {
          invalids.push(c);
          c.el.closest('label').classList.add('playah-vn-field--invalid');
        }
      });

      if (invalids.length) {
        invalids[0].el.focus();
        invalids[0].el.closest('label').scrollIntoView({ behavior: 'smooth', block: 'center' });
        alert('Vui lòng điền các trường bắt buộc:\n• ' + invalids.map(c => c.label).join('\n• '));
        submitBtn.disabled = false; submitBtn.textContent = origText; return;
      }

      if (!/^(0|\+84)[0-9]{9,10}$/.test(phone)) {
        form.elements.phone.closest('label').classList.add('playah-vn-field--invalid');
        form.elements.phone.focus();
        alert('Số điện thoại không đúng định dạng (ví dụ: 0987654321).');
        submitBtn.disabled = false; submitBtn.textContent = origText; return;
      }

      // (4) v3.9: email luôn có (đã qua requiredChecks) → luôn kiểm tra định dạng
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        form.elements.email.closest('label').classList.add('playah-vn-field--invalid');
        form.elements.email.focus();
        alert('Email không đúng định dạng (ví dụ: ban@gmail.com).');
        submitBtn.disabled = false; submitBtn.textContent = origText; return;
      }

      const provName = provincesMap.get(provCode)?.[1] || '';
      const distName = districtsMap.get(distCode)?.[1] || '';
      let wardName = '';
      if (wardCode && wardCode !== '0') {
        const dist = districtsMap.get(distCode);
        const ward = dist && dist[2] ? dist[2].find(w => w[0] === wardCode) : null;
        wardName = ward ? ward[1] : '';
      }

      const nameParts = fullName.split(/\s+/);
      const firstName = nameParts.pop() || fullName;
      const lastName = nameParts.join(' ') || firstName;

      const parts = [addressDetail];
      if (wardName) parts.push(wardName);
      if (distName) parts.push(distName);
      const address1 = parts.join(', ');
      const address2 = '';

      const cityValue = provName.replace(/^(Thành phố |Tỉnh )/i, '');

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Họ và tên': fullName,
            'Số điện thoại': phone,
            'Email': email || '(không có)',
            'Phường/Xã': wardName || '(không có)',
            'Quận/Huyện': distName,
            'Tỉnh/Thành phố': provName,
            'Địa chỉ chi tiết': addressDetail,
            'vn_full_name': fullName,
            'vn_phone': phone,
            'vn_email': email,
            'vn_address_detail': addressDetail,
            'vn_ward': wardName,
            'vn_ward_code': wardCode || '',
            'vn_district': distName,
            'vn_district_code': distCode,
            'vn_province': provName,
            'vn_province_code': provCode
          },
          note: note
        })
      });

      // (3) KITE-FIX: BỎ khối build itemsParam + cart permalink.
      // Giữ nguyên giỏ hiện tại (giữ line properties của gift + kite_campaign attributes).
      const p = new URLSearchParams();
      // (4) v3.9: email bắt buộc → luôn pre-fill vào checkout
      p.set('checkout[email]', email);
      p.set('checkout[shipping_address][first_name]', firstName);
      p.set('checkout[shipping_address][last_name]', lastName);
      p.set('checkout[shipping_address][address1]', address1);
      p.set('checkout[shipping_address][address2]', address2);
      p.set('checkout[shipping_address][city]', cityValue);
      p.set('checkout[shipping_address][country]', 'Vietnam');
      p.set('checkout[shipping_address][phone]', phone);
      p.set('checkout[billing_address][first_name]', firstName);
      p.set('checkout[billing_address][last_name]', lastName);
      p.set('checkout[billing_address][address1]', address1);
      p.set('checkout[billing_address][address2]', address2);
      p.set('checkout[billing_address][city]', cityValue);
      p.set('checkout[billing_address][country]', 'Vietnam');
      p.set('checkout[billing_address][phone]', phone);

      // (3) KITE-FIX: KHÔNG truyền attributes[...] và note qua URL — query attributes
      // GHI ĐÈ toàn bộ cart attributes → xoá kite_campaign/_kite_ccdData của app free-gift.
      // Attributes + note đã được lưu qua /cart/update.js ngay phía trên.

      // (3) Giữ giỏ hiện tại → discount free gift còn nguyên ở checkout
      window.location.href = `/checkout?${p.toString()}`;
    } catch (err) {
      console.error('[PlayAh VN] Submit error:', err);
      alert('Có lỗi xảy ra. Vui lòng thử lại.\n' + err.message);
      submitBtn.disabled = false;
      submitBtn.textContent = origText;
    }
  });


  form.addEventListener('change', function(e) {
    const lbl = e.target.closest('label');
    if (lbl) lbl.classList.remove('playah-vn-field--invalid');
  });
  form.addEventListener('input', function(e) {
    const lbl = e.target.closest('label');
    if (lbl) lbl.classList.remove('playah-vn-field--invalid');
  });

})();